module.exports = __webpack_public_path__ + "static/media/umbrella.dd0f997a.svg";